import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Tranche } from 'src/app/model/tranche.model';
import { AgenteFinanceiroService } from 'src/app/shared/services/agente-financeiro.service';
import { LimiteHonraAgenteFinanceiro } from 'src/app/model/limite-agente-financeiro.model';
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ModalidadeGarantiaService } from "../../../modalidade_garantia/modalidade-garantia.service";

import moment from "moment";
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { ModalidadeGarantia } from '../../../../model/modalidade_garantia.model';
import { RenunciaService } from 'src/app/features/renuncia/renuncia.service';
import { MensagemService } from 'src/app/features/mensagem.service';

const numeroTrancheExperado = '1';

@Component({
    selector: 'app-stoploss-listagem',
    templateUrl: './stoploss-listagem.component.html',
    styleUrls: ['./stoploss-listagem.component.css'],
    standalone: false
})
export class StoplossListagemComponent implements OnInit, OnChanges {

    @Input() agenteFinanceiro: AgenteFinanceiro;
    @Input() janelaReferencia: string;
    @Input() refresh: any;
    @Input() ideTranche: number;
    @Input() tranches: Tranche[];

    public limites: LimiteHonraAgenteFinanceiro[];
    public dataLimites: string = undefined;
    public modalidadeGarantiaDTO: ModalidadeGarantia;
    public tranche: Tranche;
    public tranchePossuiVLMei: boolean;
    public tranchePossuiVLMi: boolean;
    public tranchePossuiVLP: boolean;
    public tranchePossuiVLM: boolean;
    public tranchePossuiVLG: boolean;
    public exibeCamposRCMI: boolean;
    public dataReferencia: moment.Moment;

    public siglaValorLiberado: string;
    public textoValorLiberadoLegenda: string;
    public siglaMei: string;
    public siglaMi: string;
    public siglaP: string;
    public siglaM: string;
    public siglaG: string;

    constructor(private agenteFinanceiroService: AgenteFinanceiroService,
      private loadingService: BnLoadingService,
      private fileUtils: FileUtilsService,
      private modalidadeGarantiaService: ModalidadeGarantiaService,
      private renunciaService: RenunciaService,
      private mensagemService: MensagemService) {
    }

    ngOnInit() {
      this.modalidadeGarantiaService.buscarModalidade().subscribe((resp:any) => {
        this.modalidadeGarantiaDTO = resp;
      });
      this.preencheTranche();
      this.buscaLimiteAgenteFinanceiro();
    }

    private preencheTranche() {
        if (this.tranches) {
            this.tranches.forEach(tranche => {
                if (tranche.id == this.ideTranche) {
                    this.tranche = tranche;

                    const colunas = tranche.colunasValorLiberadoStopLoss || [];

                    // em PRD, nos, incorretamente, calculamos os valores sem aplicar percentual garantido. Entao precisamos deixar os headers coerentes com os valores exibidos
                    const janelaAnteriorASet2026 = this.janelaStringToDate().isBefore(moment('08/2026', 'MM/YYYY'));                  

                    const prefixo = janelaAnteriorASet2026
                      ? 'VL'
                      : (colunas.some(sigla => sigla.startsWith('VGL')) ? 'VGL' : 'VL');

                    this.siglaValorLiberado = prefixo == 'VGL' ? 'VGL' : 'VLO';
                    this.textoValorLiberadoLegenda = prefixo == 'VGL' ? 'Valor garantido liberado' : 'Valor liberado';

                    this.siglaMei = prefixo + 'Mei';
                    this.siglaMi = prefixo + 'Mi';
                    this.siglaP = prefixo + 'P';
                    this.siglaM = prefixo + 'M';
                    this.siglaG = prefixo + 'G';

                    this.tranchePossuiVLMei = !tranche.possuiTaxaStopLossUnica && colunas.includes(this.siglaMei);
                    this.tranchePossuiVLMi = !tranche.possuiTaxaStopLossUnica && colunas.includes(this.siglaMi);
                    this.tranchePossuiVLP = !tranche.possuiTaxaStopLossUnica && colunas.includes(this.siglaP);
                    this.tranchePossuiVLM = !tranche.possuiTaxaStopLossUnica && colunas.includes(this.siglaM);
                    this.tranchePossuiVLG = !tranche.possuiTaxaStopLossUnica && colunas.includes(this.siglaG);
                }
            });

            if (this.tranche) {
                this.deveExibirRCMIeCMIAposRCMI(this.tranche);
            }
        }
    }

    public deveExibirCMI(tranche) {
      return !tranche.possuiTaxaStopLossUnica;
    }

    deveExibirRCMIeCMIAposRCMI(tranche: Tranche) {
      const ideAgenteFinanceiro = this.verificaIdAgenteFinanceiro();
      const numeroTranche = tranche.numeroTranche?.toString();
      const ideTranche = tranche?.id;
      const dataJanela = this.janelaStringToDate();

      this.renunciaService.getExistenciaApuracaoRenunciasPorTranche(ideAgenteFinanceiro, ideTranche).subscribe({
        next: apuracao => {
          this.dataReferencia = moment(apuracao?.mesAnoApuracao).startOf('month');
          this.exibeCamposRCMI = (numeroTranche === numeroTrancheExperado) && (dataJanela.isSameOrAfter(this.dataReferencia));
        },
        error: err => {
          this.mensagemService.adicionarMensagemErro('Erro ao buscar apuração renuncia.');
        }
      })
    }

    verificaIdAgenteFinanceiro() {
      const ideAgenteFinanceiro = this.agenteFinanceiro?.id
      return ideAgenteFinanceiro == -1 ? null : ideAgenteFinanceiro;
    }

    janelaStringToDate(): moment.Moment {
      return moment(this.janelaReferencia, 'MM/YYYY');
    }

    ngOnChanges(changes) {
      if (changes.refresh) {
        this.buscaLimiteAgenteFinanceiro();
        this.preencheTranche();
      }
      if (changes.tranches) {
        this.preencheTranche();
      }
    }

    exportarRelatorioAnalitico(idLimiteHonra: number) {
      this.agenteFinanceiroService.buscaRelatorioAnalitico(idLimiteHonra).subscribe((conteudoRelatorio) => {
        this.fileUtils.exportarArquivo(`relatorio_analitico_${idLimiteHonra}.txt`, conteudoRelatorio, FileUtilsService.TEXT_PLAIN);
      });
    }

    private buscaLimiteAgenteFinanceiro() {
        this.limites = undefined;
        this.dataLimites = undefined;
        if (this.agenteFinanceiro && this.janelaReferencia) {
            let msgErro404 = "Não existem limites de honra calculados para o mês de apuração especificado.";
            if (this.agenteFinanceiro.id === -1) {
              this.loadingService.bloqueiaTela();
              this.agenteFinanceiroService.buscaLimitesHonraFg2(this.janelaReferencia, this.ideTranche, msgErro404)
                .subscribe((resp) => {
                    this.limites = resp.sort((a, b) => a.agenteFinanceiro?.nome?.localeCompare(b?.agenteFinanceiro?.nome));
                    this.dataLimites = moment().format('YYYY-MM-DD HH:mm:ss');
                    this.loadingService.liberaTela();
              }, () => {
                this.loadingService.liberaTela();
              });
            } else {
              this.loadingService.bloqueiaTela();
              this.agenteFinanceiroService.buscaLimiteHonraFg2(this.janelaReferencia,
                    this.ideTranche,
                    this.agenteFinanceiro.cnpj,
                    msgErro404).subscribe((resp) => {
                this.limites = resp;
                this.dataLimites = moment().format('YYYY-MM-DD HH:mm:ss');
                this.loadingService.liberaTela();
              }, () => {
                this.loadingService.liberaTela();
              });
            }
        }
    }

  somarColuna(campo: string): number{

    if(!this.limites || this.limites.length === 0) return 0;

    return this.limites.reduce((total, limite) =>{
      return total + Number(limite[campo] || 0);
    }, 0);
  }
}
